import { Injector, Pipe, PipeTransform } from "@angular/core";
import { LaasSettingService } from "src/app/core/services/laas-setting.service";

@Pipe({
    name: "Activated"
})

export class ActivatedPipe implements PipeTransform {

  laasSetting: LaasSettingService;
  constructor(injector: Injector) {
    this.laasSetting = injector.get(LaasSettingService);
  }

    transform(activated: number): String {
      if (this.laasSetting.language == "en-us") {
        return activated === 1 ? "activated" : "not activated"
      } else {
        return activated === 1 ? "已啟用" : "未啟用"
      }
    }
}
